import {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
  type FC,
  type ReactNode,
} from 'react';
import { t } from '../i18n';

/**
 * Tasdiqlash oynasi — `window.confirm` o'rniga.
 *
 * Mini App ichida bu ayniqsa muhim: brauzerning o'z oynasi sarlavhasida
 * DOMENNI ko'rsatadi ("shaftoli.wedev.uz says") va tugmalari inglizcha
 * bo'ladi. O'quvchi Telegram ichida o'tirib, birdan begona brauzer
 * oynasini ko'radi — ilova buzilgandek taassurot qoladi.
 *
 * Bu yerda esa ilovaning o'z varaq (sheet) uslubi ishlatiladi.
 */
export interface ConfirmOptions {
  title: string;
  body?: string;
  confirmText?: string;
  danger?: boolean;
}

type ConfirmFn = (opts: ConfirmOptions) => Promise<boolean>;

const ConfirmContext = createContext<ConfirmFn | null>(null);

export function useConfirm(): ConfirmFn {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm faqat ConfirmProvider ichida');
  return ctx;
}

export const ConfirmProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [opts, setOpts] = useState<ConfirmOptions | null>(null);
  const resolveRef = useRef<((v: boolean) => void) | null>(null);

  const confirm = useCallback<ConfirmFn>((o) => {
    setOpts(o);
    return new Promise<boolean>((resolve) => {
      resolveRef.current = resolve;
    });
  }, []);

  const close = (result: boolean) => {
    resolveRef.current?.(result);
    resolveRef.current = null;
    setOpts(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}

      {opts && (
        <div
          className="sheet-backdrop"
          role="dialog"
          aria-modal="true"
          aria-label={opts.title}
          onClick={() => close(false)}
        >
          <div className="sheet" onClick={(e) => e.stopPropagation()}>
            <div className="sheet-handle" aria-hidden="true" />

            <h2 style={{ marginBottom: opts.body ? 'var(--space-2)' : 0 }}>
              {opts.title}
            </h2>
            {opts.body && (
              <p className="secondary" style={{ whiteSpace: 'pre-line' }}>
                {opts.body}
              </p>
            )}

            <div className="sheet-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => close(false)}
              >
                {t('Bekor qilish')}
              </button>
              <button
                type="button"
                className={`btn ${opts.danger ? 'btn-danger' : 'btn-primary'}`}
                onClick={() => close(true)}
                autoFocus
              >
                {opts.confirmText || t('Davom etish')}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};
